/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";

// import { useAuth } from "../../../context/AuthContext";
import { toast } from "react-toastify";
import AppsModal from "../MfaModals/appsModal";
import QRCodeModal from "../MfaModals/QRCodeModal";
import SuccessModal from "../MfaModals/successModal";
import InstructionAppModal from "../MfaModals/instructionAppModal";

const MfaConfig = ({ userInfo, setOpenConfigModals }) => {
  const [appModal, setAppModal] = useState(true);
  const [instructionAppModal, setInstructionAppModal] = useState(false);
  const [QRModal, setQRModal] = useState(false);
  const { email, password } = userInfo || {};
  const [successModal, setSuccessModal] = useState(false);
  const [backupCode, setBackupCode] = useState("");

  const handleInstructionAppModal = () => {
    setInstructionAppModal(!instructionAppModal);
    setAppModal(false);
  };
  const handleQRModal = () => {
    setQRModal(!QRModal);
    setInstructionAppModal(false);
  };
  const handleBackupCode = (code) => {
    setBackupCode(code);
  };
  const handleSuccessModal = () => {
    setSuccessModal(!successModal);
    setQRModal(false);
  };

  const handleSuccesToggle = () => {
    setSuccessModal(!successModal);
    setBackupCode("");
    toast.success("Inicia sesión con autenticación de dos factores");
  };

  return (
    <>
      <AppsModal
        isOpen={appModal}
        button={false}
        handleNextModal={handleInstructionAppModal}
        toggle={() => {
          setAppModal(!appModal);
          setOpenConfigModals(false);
        }}
      />
      <InstructionAppModal
        isOpen={instructionAppModal}
        button={false}
        handleNextModal={handleQRModal}
        toggle={() => {
          setInstructionAppModal(!instructionAppModal);
          setOpenConfigModals(false);
        }}
      />
      <QRCodeModal
        userName={email || null}
        password={password || null}
        isOpen={QRModal}
        button={false}
        handleNextModal={handleSuccessModal}
        toggle={() => {
          setQRModal(!QRModal);
          setOpenConfigModals(false);
        }}
        setBackupCode={handleBackupCode}
      />
      <SuccessModal
        isOpen={successModal}
        button={false}
        toggle={() => {
          handleSuccesToggle();
          setOpenConfigModals(false);
        }}
        backupCode={backupCode}
        setBackupCode={handleBackupCode}
      />
    </>
  );
};

export default MfaConfig;
